import * as THREE from 'three';

const FLOCKS = [
  { x: -210, y: 145, z: -2250, radius: 110, speed: 0.42 },
  { x: 510, y: 290, z: -4350, radius: 140, speed: -0.34 },
  { x: -430, y: 190, z: -6650, radius: 125, speed: 0.51 },
  { x: 210, y: 115, z: -9100, radius: 100, speed: -0.46 },
  { x: 30, y: 75, z: -11100, radius: 85, speed: 0.58 }
];

function makeBird() {
  const group = new THREE.Group();
  const material = new THREE.MeshStandardMaterial({
    color: '#242b2d', roughness: 0.78, metalness: 0.05, side: THREE.DoubleSide
  });
  const breast = new THREE.Mesh(
    new THREE.CapsuleGeometry(0.32, 1.05, 4, 8),
    material
  );
  breast.rotation.x = Math.PI / 2;
  breast.castShadow = true;
  const head = new THREE.Mesh(new THREE.SphereGeometry(0.3, 10, 6), material);
  head.position.z = -0.78;
  head.castShadow = true;
  const beak = new THREE.Mesh(
    new THREE.ConeGeometry(0.12, 0.45, 6),
    new THREE.MeshStandardMaterial({ color: '#c79246', roughness: 0.8 })
  );
  beak.rotation.x = -Math.PI / 2;
  beak.position.z = -1.05;
  group.add(breast, head, beak);

  const wingGeometry = new THREE.BufferGeometry();
  wingGeometry.setAttribute('position', new THREE.Float32BufferAttribute([
    0, 0, 0, 2.2, 0, 0.2, 0.25, 0, 0.75
  ], 3));
  wingGeometry.computeVertexNormals();
  const leftWing = new THREE.Mesh(wingGeometry, material);
  const rightWing = new THREE.Mesh(wingGeometry, material);
  rightWing.scale.x = -1;
  leftWing.castShadow = true;
  rightWing.castShadow = true;
  group.add(leftWing, rightWing);
  group.userData.leftWing = leftWing;
  group.userData.rightWing = rightWing;
  return group;
}

export class BirdSystem {
  constructor(scene) {
    this.birds = [];
    this.triggered = new Set();
    let birdId = 0;
    FLOCKS.forEach((flock, flockIndex) => {
      for (let index = 0; index < 7; index += 1) {
        const bird = makeBird();
        bird.scale.setScalar(0.72 + (index % 3) * 0.12);
        bird.userData = {
          ...bird.userData,
          id: birdId,
          flockIndex,
          offset: (index / 7) * Math.PI * 2,
          layer: (index % 3) - 1,
          base: flock
        };
        scene.add(bird);
        this.birds.push(bird);
        birdId += 1;
      }
    });
  }

  reset() {
    this.triggered.clear();
  }

  update(time, planePosition, onEvent) {
    for (const bird of this.birds) {
      const data = bird.userData;
      const angle = time * data.base.speed + data.offset;
      bird.position.set(
        data.base.x + Math.cos(angle) * (data.base.radius + data.layer * 19),
        data.base.y + Math.sin(time * 1.7 + data.offset) * 14 + data.layer * 7,
        data.base.z + Math.sin(angle) * data.base.radius * 0.58
      );
      bird.rotation.y = -angle + (data.base.speed > 0 ? Math.PI : 0);
      const flap = Math.sin(time * 8.5 + data.offset) * 0.78;
      data.leftWing.rotation.z = flap;
      data.rightWing.rotation.z = -flap;

      if (!planePosition || this.triggered.has(data.id)) continue;
      const distance = bird.position.distanceTo(planePosition);
      if (distance < 3.2) {
        this.triggered.add(data.id);
        onEvent?.('strike', bird.position.clone());
      } else if (distance < 13) {
        this.triggered.add(data.id);
        onEvent?.('near-miss', bird.position.clone());
      }
    }
  }
}
